import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { colors } from "../../theme/theme";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress, useMediaQuery } from "@mui/material";
import { CustomPasswordInput } from "../../components/CustomInput";
import CustomBtn from "../../components/CustomBtn";
import { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../constants/config";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../components/CustomSnackbar";
export default function ResetPassword() {
  const navigate = useNavigate();
  const params = useParams();
  const smallScreen = useMediaQuery("(max-width:800px)");

  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  const [confirmation, setconfirmation] = useState(false);
  const [confirmationMsg, setconfirmationMsg] = useState("");

  const [password, setpassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    if (password === "" || confirmPassword === "") {
      seterror(true);
      seterrorMsg("All fields are required.");
    } else if (password !== confirmPassword) {
      seterror(true);
      seterrorMsg("Password and confirm password mismatched.");
    } else {
      setloading(true);
      seterror(false);
      await axios
        .post(`${BASE_URL}/user/updatedUserPassword`, {
          userId: params?.id,
          otp: params?.token,
          password: password,
        })
        .then((res) => {
          setloading(false);
          seterror(false);
          setconfirmation(true);
          setconfirmationMsg("Password Updated Successfully.");
          setTimeout(() => {
            setconfirmation(false);
          }, 4000);

          navigate("/login");
        })
        .catch((e) => {
          setloading(false);
          seterror(true);
          seterrorMsg(e.response?.data?.message);
        });
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{ height: "100vh", backgroundColor: "#F7F8FA" }}
    >
      <CssBaseline />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={error}
        handleCloseError={seterror}
        errorMsg={errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={confirmation}
        text={confirmationMsg}
        handleSnackbarClose={setconfirmation}
      />
      <Grid
        item
        xs={false}
        sm={5}
        md={6.5}
        sx={{
          backgroundImage: `url(${require("../../assets/images/login/banner2.webp")})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "40%",
            backgroundImage:
              "linear-gradient(180deg, rgba(8, 13, 27, 0) 0%, rgba(8, 13, 27, 0.9) 100%)", // Adjusted alpha value to make it darker
          }}
        />
        <img
          src={require("../../assets/images/logo_md.png")}
          alt="Logo"
          style={{
            position: "absolute",
            top: "7.5%",
            left: "7.5%",
          }}
        />
        <Typography
          sx={{
            fontWeight: "500",
            color: "#fff",
            fontSize: smallScreen ? "20px" : "28px",
            fontFamily: "FiraSans",
            position: "absolute",
            bottom: "10%",
            marginLeft: "7.5%",
          }}
        >
          Empowering Mental Wellness:
          <Typography
            sx={{
              fontWeight: "800",
              color: "#fff",
              fontSize: smallScreen ? "34px" : "44px",
              fontFamily: "FiraSans",
            }}
          >
            Transforming Lives Through Compassionate Online Hypnotherapy
          </Typography>
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={7}
        md={5.5}
        component={Paper}
        elevation={6}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F7F8FA",
          position: "relative",
        }}
      >
        <Box
          sx={{
            my: smallScreen ? 0 : 6,
            mx: smallScreen ? 0 : 9,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            fontFamily="FiraSans"
            fontWeight={"bold"}
            color={colors.textColor}
            fontSize={34}
          >
            Reset Password
          </Typography>
          {/* <Typography
            component="h1"
            variant="body1"
            fontFamily="FiraSans"
            fontWeight={"400"}
            color={colors.subText}
            fontSize={18}
          >
            We’ve already met!
          </Typography> */}
          <Box component="form" noValidate sx={{ mt: 4, px: 8 }}>
            {/* <CustomInput
              value={email}
              setValue={setemail}
              placeholder="Email Address"
              Icon={MailOutlineIcon}
            /> */}
            <CustomPasswordInput
              mT
              mB
              value={password}
              setValue={setpassword}
            />
            <CustomPasswordInput
              mT
              mB
              title="Confirm Password"
              value={confirmPassword}
              setValue={setconfirmPassword}
            />

            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "20%",
                backgroundImage: `url(${require("../../assets/images/login/bottom.webp")})`,
              }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomBtn
                text="Update Password"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogin(e);
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              Already have an account
              <Link to="/login" variant="body2" style={{ color: "green" }}>
                &nbsp; Sign In
              </Link>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
